
import BinanceUsd from "../../../assets/filled/BinanceUsd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function BinanceUsdIcon({ className, dataTestid = "BinanceUsdIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <BinanceUsd data-testid={dataTestid} className={classes} {...rest} />
  );
}
